import React from "react";
import CartForm from './../Forms/CartForm.jsx';
import { Storage } from './../Core/Storage';
import  CartProducts  from './../Components/CartProducts.jsx';

export default class Cart extends React.Component {
	
	state = {
	}
	
	render() {
		return (<div className="page-cover">
			<CartForm />
		</div>);
	}
}
